import { useEffect, useState } from 'react';

/**
 * matchMedia breakpoint hook — ported from `apps/marketing`'s `MarketingShell`
 * `useIsCompact` (kept as the exact same idiom) and generalised to take a
 * breakpoint so the same hook drives both:
 *   - the dashboard nav drawer collapse (720px), and
 *   - the two-pane → single-column layout collapse (820px).
 *
 * Returns `true` when the viewport is at or below `maxWidth` px.
 *
 * SSR / pre-mount safe: defaults to `false` (desktop) before the effect runs,
 * then syncs on mount and stays live via the `change` listener.
 */
export function useIsCompact(maxWidth = 720): boolean {
  const [compact, setCompact] = useState(false);
  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mq = window.matchMedia(`(max-width: ${maxWidth}px)`);
    const onChange = () => setCompact(mq.matches);
    onChange();
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, [maxWidth]);
  return compact;
}
